module.exports = __webpack_public_path__ + "static/media/house_empty.fdfca512.png";